export const body = {
    padding: "30px",
    textAlign: "center"
};
